import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./lib/i18n"; // Initialize i18n
import { ClerkProvider } from "@clerk/clerk-react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ConvexReactClient } from "convex/react";
import { useAuth } from "@clerk/clerk-react";

const convexUrl = import.meta.env.VITE_CONVEX_URL;
const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// Fail gracefully if env vars are missing (prevents blank screen crash)
if (!convexUrl || !publishableKey) {
  const missing = [];
  if (!convexUrl) missing.push("VITE_CONVEX_URL");
  if (!publishableKey) missing.push("VITE_CLERK_PUBLISHABLE_KEY");
  
  document.getElementById("root")!.innerHTML = `
    <div style="padding: 2rem; font-family: system-ui; text-align: center;">
      <h1 style="color: #ef4444;">Configuration Error</h1>
      <p>Missing environment variables:</p>
      <pre style="background: #f3f4f6; padding: 1rem; border-radius: 0.5rem; display: inline-block;">
${missing.join("\n")}
      </pre>
      <p>Please check your Vercel Project Settings.</p>
    </div>
  `;
  throw new Error(`Missing env vars: ${missing.join(", ")}`);
}

const convex = new ConvexReactClient(convexUrl);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <App />
      </ConvexProviderWithClerk>
    </ClerkProvider>
  </React.StrictMode>
);
